type RatingsReviewProps = {
  title: string;
  description: string;
  icon: string;
};

export const RatingsReview = ({
  title,
  description,
  icon,
}: RatingsReviewProps) => {
  return (
    <div className="flex gap-4 items-start py-6 px-8 bg-white rounded-lg border border-black/10">
      {/*TODO: re-enable or remove feature once we know if we keep icons or not*/}
      {/*<div className="mt-0.5">*/}
      {/*  <Image*/}
      {/*    src={`/content/icons/${icon}.svg`}*/}
      {/*    alt=""*/}
      {/*    width={24}*/}
      {/*    height={24}*/}
      {/*  />*/}
      {/*</div>*/}

      <div className="flex-1">
        <p className="text-xl font-bold lg:text-2xl">{title}</p>
        <p className="lg:text-lg">{description}</p>
      </div>
    </div>
  );
};
